<ng-container *ngIf="initialized">
  <ng-container *ngIf="deviceService.isMobileSmDown$ | async; else desktopDeliveryMap">
    <div class="d-flex flex-wrap mb-3 mb-md-4">
      <h2 class="order-1 title-wrapper">Зона доставки</h2>
    </div>
    <ui-address-suggestions-select
      (changeAddress)="onChangeAddress($event)"
      label="Поставьте точку на карте, чтобы рассчитать стоимость"
    ></ui-address-suggestions-select>
    <sd-ymap class="map order-2" [geoObjects]="geoObjects$ | async" (created)="onMapCreated($event)"></sd-ymap>
  </ng-container>

  <ng-template #desktopDeliveryMap>
    <div class="d-flex flex-wrap title-section">
      <div class="title-wrapper">
        <h2>Зона доставки</h2>
      </div>
    </div>
    <ui-address-suggestions-select
      (changeAddress)="onChangeAddress($event)"
      label="Поставьте точку на карте, чтобы рассчитать стоимость"
    ></ui-address-suggestions-select>
    <sd-ymap class="map" [geoObjects]="geoObjects$ | async" (created)="onMapCreated($event)"></sd-ymap>
  </ng-template>
</ng-container>
